module.exports = __webpack_public_path__ + "static/media/GEM _ PROMO_OFFICIAL 2017.0de6456f.mp4";